import type { LengthUnits } from '@peles/shared';
import { ToolbarToggleGroup, type ToolbarToggleOption } from './ToolbarToggleGroup';

const OPTIONS: ToolbarToggleOption<LengthUnits>[] = [
  { value: 'ft', label: 'ft', title: "Show lengths in feet (6.5')", testId: 'length-units-ft' },
  {
    value: 'ftin',
    label: 'ft-in',
    title: 'Show lengths in feet and inches (6\' 6")',
    testId: 'length-units-ftin',
  },
];

interface LengthUnitsToggleProps {
  units: LengthUnits;
  onChange: (units: LengthUnits) => void;
}

/**
 * Feet or feet and inches for every length the plan shows — the size fields,
 * the library, the labels on the canvas and the measuring tool. Either can
 * be typed into a size field whichever is chosen.
 */
export function LengthUnitsToggle({ units, onChange }: LengthUnitsToggleProps) {
  return (
    <ToolbarToggleGroup
      ariaLabel="Show lengths in"
      data-testid="length-units-toggle"
      options={OPTIONS}
      value={units}
      onChange={onChange}
    />
  );
}
